import { styled } from '@mui/material'

export const IconLink = styled('a')(({ theme }) => ({
  borderRadius: '8px',
  border: `1px solid ${theme.palette.border['brand-subtle']}`,
  background: theme.palette.background.surface,
  display: 'flex',
  padding: '4px',
  alignItems: 'center',
  justifyContent: 'center',
  height: '40px',
  minWidth: '40px',
  width: '40px',

  '> svg': {
    height: '100%',
    width: '100%',
  },
}))
